module.exports = __webpack_public_path__ + "WP.svg?43a9820e97c9f12462a7234cb1db39f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/WP.svg
// module id = 76
// module chunks = 0